// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__wbW2X","title":"styles_title__-xjph"};